import { ConfirmationModal } from "../ConfirmationModal";
import React, {HTMLAttributes, JSX, useState} from "react";

export interface ConfirmationDialogProps extends HTMLAttributes<'span'>{
	onSubmit?: () => Promise<any>;
	title: string;
	loading?: boolean;
	action: JSX.Element;
}

export const ConfirmationDialog = (props: ConfirmationDialogProps) => {
	const { onSubmit, title, children, action, loading = false } = props;
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			{React.cloneElement(action, { onClick: () => {
				setIsOpen(true);
			}})}
			<ConfirmationModal
				onAgree={() => {
					if (onSubmit) {
						onSubmit().then(() => {
							setIsOpen(false);
						});
					}
				}}
				title={title}
				text={children}
				loading={loading}
				isOpen={isOpen}
				onClose={() => {
					setIsOpen(false)
				}}
			/>
		</>
	)
}
